import React from "react";
import NavBar from "../components/NavBar";
import HeroImage2 from "../components/HeroImage2";
import ContactForm from "../components/ContactForm";
import Footer from "../components/Footer";

const Contact = () => {
  return (
    <div>
      <NavBar />
      <HeroImage2
        bgImage="hero-img-contact"
        heading="LET'S TALK ABOUT YOUR PROJECT"
        text="Need help on your projects? Reach out through the form below!"
      />
      <ContactForm />
      {/* <Footer /> */}
    </div>
  );
};

export default Contact;
